import { normalizeTopSellingEventsGenre } from '@utils/storeDataNormalization';
import topSellingEventsModuleFactory from '@helpers/storeFactories/moduleFactory';
import { apiService } from '@api';

const STORE_NAME = 'genre';

const store = topSellingEventsModuleFactory.createModuleView(STORE_NAME, apiService, {
    customListFormatter: normalizeTopSellingEventsGenre,
    customListFetchFn: apiService.topSellingEvents.genre.get,
});

export default store;
